document.addEventListener("DOMContentLoaded", function() {
    // console.log("DOM completamente cargado y analizado");

    function updateEmailLinks() {
        var domain = window.location.hostname;
        // console.log("Dominio actual:", domain);

        // Selecciona todos los elementos con la clase 'pango-dominio'
        var emailElements = document.querySelectorAll('.pango-dominio');

        if (emailElements.length > 0) {
            emailElements.forEach(function(emailElement) {
                // console.log("Elemento encontrado:", emailElement.href, "Texto:", emailElement.textContent);

                // Verifica si el `href` empieza con el valor que necesita ser cambiado
                if (emailElement.href.startsWith('mailto:info@foodforjoe')) {
                    var newHref = domain.endsWith('.pt') ? 'mailto:info@foodforjoe.pt' : 
                                 domain.endsWith('.es') ? 'mailto:info@foodforjoe.es' : 
                                 domain.endsWith('.it') ? 'mailto:info@foodforjoe.it' : null;
                    var newText = domain.endsWith('.pt') ? 'info@foodforjoe.pt' : 
                                 domain.endsWith('.es') ? 'info@foodforjoe.es' : 
                                 domain.endsWith('.it') ? 'info@foodforjoe.it' : null;

                    if (newHref && (emailElement.href !== newHref || emailElement.textContent.trim() !== newText)) {
                        emailElement.href = newHref;
                        emailElement.textContent = newText;
                        // console.log("Correo electrónico cambiado a:", newHref);
                    } else {
                        // console.log("No se necesita cambio para el enlace:", emailElement.href);
                    }
                }
            });
        } else {
            // console.log("No se encontraron elementos con la clase 'pango-dominio'.");
        }
    }

    function hideWhatsApp() {
        var domain = window.location.hostname;
        var whatsappElement = document.querySelector('.whatsapp-element'); // Cambia '.whatsapp-element' por la clase o ID correcta

        if (whatsappElement) {
            if (domain.endsWith('.pt') || domain.endsWith('.it')) {
                whatsappElement.style.display = 'none';
                // console.log("Elemento de WhatsApp oculto para el dominio:", domain);
            }
        } else {
            // console.log("No se encontró el elemento de WhatsApp.");
        }
    }

    // Usar setInterval para intentar cambiar el correo electrónico repetidamente
    var intervalId = setInterval(function() {
        var emailElements = document.querySelectorAll('.pango-dominio');
        if (emailElements.length > 0) {
            setTimeout(function() {
                updateEmailLinks();
                hideWhatsApp(); // Ocultar WhatsApp si es necesario
                clearInterval(intervalId); // Detener el intervalo una vez que se haya realizado el cambio
            }, 500); // 500 ms de retraso
        }
    }, 500); // Intentar cada 500 ms
});
